// extracted by mini-css-extract-plugin
export default {"AutoExpand":"Header_AutoExpand__d75wi","content":"Header_content__iRQsp","expandable":"Header_expandable__PV+cY"};